import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'

export let startCourseNav = data => {
  ReactDOM.render(
    <App
      courseTitle={data.course_title}
      coursenum={data.coursenum}
      books={data.books}
      archivedBooks={data.archivedBooks}
      contentTitle={data.contentTitle}
      contents={data.contents}
      demo={data.demo === 'true'}
    />,
    document.getElementById('courseNavApp')
  )
}
